import { createFileRoute, redirect } from '@tanstack/react-router'
import { useDeeplinks } from '../../route'

export const Route = createFileRoute('/app/deeplinks/programs/$programId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { defaultOrg } = useDeeplinks()
  throw redirect({ to: `/app/organizations/${defaultOrg.id}` })
}
